import React from "react";
import { withTranslation, useTranslation } from 'react-i18next';
import ListenerComponent from './listenerComponent';

// Common tags
class CommonTags extends ListenerComponent {
  constructor(props) {
    super(props);
    let MOUNTED = false;
    this.state = {
      ...this.state,
      data: this.getTagList(this.props.type),
      tagVisible: false,
      type: this.props.type,
      meetingId: this.props.meetingId,
      id: this.props.id,
      act: this.props.act,
      ai_id: this.props.ai_id || null,
      listTag: false,
      emptyArea: this.props.emptyArea ? this.props.emptyArea : false,
    };
    this.getTagList = this.getTagList.bind(this);
    this.addTagMenuClick = this.addTagMenuClick.bind(this);
    this.trigger_meeting_tags = this.trigger_meeting_tags.bind(this);
    this.setTagsValue = this.setTagsValue.bind(this);
    this.showTagStick = this.showTagStick.bind(this);
    this.hideTagStick = this.hideTagStick.bind(this);
    this.tagRef= React.createRef();
    this.handleClickOutsideTag = this.handleClickOutsideTag.bind(this);
  }

  componentDidMount() {
    this.MOUNTED = true;
    $(document).on("meeting_tag_option", {}, this.trigger_meeting_tags);
    document.addEventListener('mousedown', this.handleClickOutsideTag);
    window.addEventListener('pushState', this.handleGlobalStateChange);
  }

  componentWillUnmount() {
    this.MOUNTED = false;
    document.removeEventListener('mousedown', this.handleClickOutsideTag);
    window.removeEventListener('pushState', this.handleGlobalStateChange);
  }

  handleClickOutsideTag(event) {
    if (this.tagRef && this.tagRef.current && !this.tagRef.current.contains(event.target)) {
      this.setState({
        tagVisible: false
      });
    }
  }

  getTagList(type) {
    const { t } = this.props;
    type = type.toLowerCase();
    type = type != "topic" ? "Takeaway" : "Topic";
    if (type == "Takeaway") {
      return [
        { id: 2, name: t("Idea") },
        { id: 3, name: t("Decision") },
        { id: 8, name: t("Red") },
        { id: 9, name: t("Amber") },
        { id: 5, name: t("Green") },
        { id: 6, name: t("Discussion") },
        { id: 7, name: t("FYI") },
        { id: 4, name: t("Note") }
      ];
    }
    if (type == "Topic") {
      return [
        { id: 2, name: t("Idea") },
        { id: 3, name: t("Decision") },
        { id: 8, name: t("Red") },
        { id: 9, name: t("Amber") },
        { id: 5, name: t("Green") },
        { id: 6, name: t("Discussion") },
        { id: 7, name: t("FYI") },
        { id: 4, name: t("Note") },
        { id: 0, name: t("Bullet") }
      ];
    }
  }

  addTagMenuClick() {
    let visible = false;
    const { userPermission } = this.props;
    const { currentUser } = this.props;
    if (userPermission.notesAccess || currentUser.id == this.props.owner) {
      visible = true;
    }

    if (visible) {
      // This is needed because the tag list can get hidden indefinitely when editor is focused; see wb-meeting.js
      $(".meeting-tag-option-list").show();
    }

    this.setState({
      tagVisible: visible
    });
  }

  trigger_meeting_tags(params) {
    if (this.MOUNTED) {
      this.setState({
        tagVisible: false
      });
    }
  }

  setTagsValue(e, tagId, topicId) {
    if (this.props.type == "topic") {
      this.props.saveTags(
        this.props.meeting.id,
        tagId,
        topicId,
        this.props.type,
        this.props.act
      );
    } else {
      this.props.saveTags(
        this.props.meeting.id,
        tagId,
        this.state.id,
        this.props.type,
        this.props.act,
        this.props.topicId
      );
    }
    this.setState({
      tagVisible: false,
      listTag: false
    });

    if (typeof this.props.getReturnTag !== "undefined") {
      this.props.getReturnTag(tagId);
    }
  }

  showTagStick(e) {
    this.setState({ listTag: true });
  }

  hideTagStick(e) {
    this.setState({ listTag: false });
  }

  render() {
    const { meeting, t } = this.props;
    let uniqids = this.props.topicId;
    const { userPermission } = this.props;
    const { currentUser } = this.props;
    let cursorP = "initial";
    if (
      meeting.status == "1" &&
      (userPermission.notesAccess || currentUser.id == this.props.owner)
    ) {
      cursorP = "pointer";
    }
    if (userPermission.notesAccess && this.state.emptyArea) {
      cursorP = "pointer";
    }

    if (uniqids != undefined) {
      uniqids = uniqids;
    } else {
      uniqids = "undefined";
    }

    const list = this.state.data.map(p => {
      if (this.props.tag != p.id) {
        if (p.id == "1" && this.state.ai_id) {
          // TODO!: fix this conditional block
        } else {
          return (
            <div
              key={`mtag_option_${p.id}`}
              className="mtagoption clickable"
              data-tag={p.id}
              onClick={event => this.setTagsValue(event, p.id, uniqids)}
            >
              <div className="mtagoptionimg" data-tag={p.id} />
              <div className="textAlignLeft">{p.name}</div>
            </div>
          );
        }
      }
    });
    const tagItem = this.state.data.map(p => {
      if (this.props.tag != p.id) {
        if (p.id == "1" && this.state.ai_id) {
          // TODO!: fix this conditional block
        } else {
          return (
            <div
              key={`meetingpopupmenu_list_${p.id}`}
              className="meetingpopupmenu-list dispIB"
              data-tag={p.id}
              onClick={event => this.setTagsValue(event, p.id, uniqids)}
              style={{ width: "126px" }}
            >
              <div className="tag-icon floatLeft" data-tag={p.id} />
              <div className="floatLeft" style={{ fontSize: "14px" }}>
                {p.name}
              </div>
            </div>
          );
        }
      }
    });
    let fromThreeDotTag = 0;
    if (
      typeof this.props.fromThreeDot !== "undefined" &&
      this.props.fromThreeDot == "1"
    ) {
      fromThreeDotTag = this.props.fromThreeDot;
    }
    const tagType = this.props.type;
    return (
      <div>
        {fromThreeDotTag ? (
          <div className="tagAddFromCommon">
            <div
              className="wspopupmenu-list clickable"
              data-type={tagType}
              data-meeting-id={meeting.id}
              data-topic-id={this.props.id}
              data-type-id={tagType}
              onMouseEnter={e => this.showTagStick(e)}
              onMouseLeave={e => this.hideTagStick(e)}
              style={{ fontSize: "14px" }}
            >
              {t('Add smart bullets')}
              {this.state.listTag && (
                <div
                  className="meetingtagpopupmenu-wrapper"
                  style={{ cursor: cursorP, top: "4%" }}
                >
                  {tagItem}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="meeting-tag-wrapper" style={{ paddingTop: "0px" }} ref={this.tagRef}>
            <div
              className="meeting-tag-options"
              data-tag={this.props.tag}
              data-type={this.props.type}
              onClick={!this.state.isSomethingPending ? () => this.addTagMenuClick() : null}
              style={{ cursor: cursorP }}
            />
            {this.state.tagVisible && (
              <div
                className="meeting-tag-option-list shadow"
                style={{ cursor: cursorP }}
              >
                {list}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

// method to initialize and add images to topic and takeaway using dropzone
export function initializeMeetingDropzone(props) {
  const { t } = useTranslation();
  if (props.s3Data) {
    const mtS3Data = props.s3Data;
    const eleId = `#${props.elementId}`;
    const { upload_max_size } = props;
    const { upload_max_size_configured } = props;
    // Check to make sure the element actually exists on the DOM, else fail silently
    if (document.getElementById(props.elementId) && window.Dropzone) {
      const myDropzone = new Dropzone(eleId, {
        url: `https://${mtS3Data.file_bucket}.s3.amazonaws.com/`,
        acceptedFiles: 'image/*',
        autoDiscover: false,
        autoProcessQueue: false,
        clickable: false,
        createImageThumbnails: false,
        maxFilesize: upload_max_size_configured,
        parallelUploads: 100,
        previewsContainer: false,
        thumbnailMethod: 'crop',
        uploadMultiple: false,
        init() {
          const myDropzone = this;
          myDropzone.on("addedfile", file => {
            if (file.size > upload_max_size) {
              this.removeFile(file);
              alert(t('The file you have uploaded exceeds the maximum size of {{size}}MB.', { size: upload_max_size_configured }));
              return;
            }
            if (file.type == 'application/x-msdownload' || file.type == 'text/mspg-legacyinfo' || file.type == 'application/x-ole-storage' || file.type == 'application/java' || file.type == 'application/octet-stream') {
              this.removeFile(file);
              alert(t('The file type you have uploaded is not supported.'));
              return;
            }
            try {
              setTimeout(() => {
                showLoaderWidget($("#content"));
                myDropzone.processQueue();
              }, 500);
            } catch (err) {
              console.error('Unable to upload file: ' + err);
            }
          });

          myDropzone.on("processing", function(file) {
            if (mtS3Data.encrypt_type === 'azure:sse') {
              myDropzone.options.url = 'azure';
            }
          });

          myDropzone.on("sending", (file, xhr, formData) => {
            const key = replaceS3Key(mtS3Data.key, file.name);
            const fileName = replaceSpcicalCharacter(file.name);
            const fileType = file.type;
            const fileSize = file.size;
            file.prefix = mtS3Data.prefix;
            file.s3DirectUpload = 1;
            formData.append("key", key);
            formData.append("policy", mtS3Data.policy);
            formData.append("acl", mtS3Data.acl);
            formData.append("success_action_status", 201);
            formData.append("Filename", fileName);
            formData.append("Content-type", fileType);
            if (mtS3Data.encrypt_type === 'azure:sse') {
              uploadFileToAzureStorage(mtS3Data.asc, key, file, null, 'anonymous')
              .then((result) => {
                file.filePath = result.filePath;
                file.s3DirectUpload = 2; // 's3 (1) | azure (2)'
                myDropzone._finished([file]);
              });
            } else if (mtS3Data.encrypt_type === 'aws:kms') {
              formData.append("x-amz-algorithm", mtS3Data.algo);
              formData.append("x-amz-credential", mtS3Data.credential);
              formData.append("x-amz-date", mtS3Data.short_date);
              formData.append("x-amz-signature", mtS3Data.signature);
            } else {
              formData.append("AWSAccessKeyId", mtS3Data.keyId);
              formData.append("signature", mtS3Data.signature);
            }
          });
          
          myDropzone.on("success", (file, response) => {
            const imgKey = mtS3Data.encrypt_type === 'aws:kms' ? 
              replaceS3Key($("Key", response).text(), file.name) : null;
            let imgLocation = (typeof file.filePath !== 'undefined')
              ? file.filePath : $("Location", response).text();
            $.ajax({
              url: `${wbConfig.baseUrl}/workboard/getS3Data`,
              type: "POST",
              dataType: "json",
              data: {
                imgKey,
                imgUrl: imgLocation,
                s3DirectUpload: file.s3DirectUpload
              }
            }).done(data => {
              const myObjectS3Data = data;
              let exisDesc = $.trim($(eleId).html());
              exisDesc = exisDesc.replace(/&nbsp;/gi, " ");
              if (typeof myObjectS3Data.imgUrl !== "undefined") {
                imgLocation = myObjectS3Data.imgUrl;
              }
              const imgTagVal = `<img class="imgViewerCtrl mtImage" src="${imgLocation}" />`;
              if (
                $(exisDesc).find(".mtImageDiv").length > 0 ||
                $(exisDesc).hasClass("mtImageDiv")
              ) {
                $(eleId)
                  .find(".mtImageDiv")
                  .append(imgTagVal);
                exisDesc = $(eleId).html();
              } else {
                exisDesc = `<div class="mtImageDiv">${exisDesc}${imgTagVal}</div>`;
              }
              props.addImg(exisDesc, myObjectS3Data);
              removeLoaderWidget();
            });
          });

          myDropzone.on("error", (files, response, xhr) => {
            try {
              toastr.error(response);
              setTimeout(() => {
                removeLoaderWidget();
                return false;
              }, 1000);
              removeLoaderWidget();
            } catch (err) {}
          });
        }
      });
    }
  }
}

export function autoResizeTextArea(props) {
  $(props.eleId).css({
    "min-height": "31px",
    height: "auto",
    "overflow-y": "hidden"
  });
  // .css("height", $(props.eleId)[0].scrollHeight);
}

export function resetTextAreaHeight(props) {
  $(props.eleId).css({
    "min-height": "31px",
    height: "auto",
    "overflow-y": "hidden"
  });
}
export default withTranslation()(CommonTags);
